module.exports = __webpack_public_path__ + "static/media/FINX-funnel.20c7bb37.png";